import type { IFieldOptions } from '@axo/form/feature/form-input/types';

export const mainBankFieldOption = {
  registerOptions: {
    shouldUnregister: true,
    required: 'MainBank.error.required',
  },
} satisfies IFieldOptions;
